// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------
export const HOST_API =
  process.env.REACT_APP_HOST_API ??
  `https://${window.location.hostname.replace('dashboard', 'dashboard.api')}`;

export const HOST_HUB =
  process.env.REACT_APP_HOST_HUB ??
  `https://${window.location.hostname.replace('dashboard', 'dashboard.api')}`;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API ?? `https://${window.location.hostname}`;
export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;
export const { SENTRY_DSN } = process.env;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

// MUI
export const MUI_LICENSE = process.env.REACT_APP_MUI_LICENSE_KEY;
